import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Clock } from "lucide-react";
import Logo from "./Logo";
import { FIRM, SERVICES } from "../data/services";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy-900 text-slate-300"
      style={{ backgroundColor: "#0A192F" }}
    >
      <div className="container-x py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo variant="light" />
            <p className="mt-6 text-sm leading-relaxed text-slate-400 max-w-sm">
              Firma multidisciplinaria de abogados y contadores. Soluciones
              jurídicas y contables integrales con rigor técnico y enfoque
              estratégico.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <span
                className="inline-block h-px w-10"
                style={{ background: "#C5A059" }}
              />
              <span
                className="text-xs uppercase tracking-[0.22em]"
                style={{ color: "#C5A059" }}
              >
                Cobertura nacional
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-serif text-white text-lg mb-5">Áreas de práctica</h4>
            <ul className="space-y-2.5 text-sm">
              {SERVICES.slice(0, 7).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/servicios/${s.slug}`}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-serif text-white text-lg mb-5">Firma</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/firma" className="text-slate-400 hover:text-white">
                  Quiénes somos
                </Link>
              </li>
              <li>
                <Link to="/mision-vision" className="text-slate-400 hover:text-white">
                  Misión y Visión
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-slate-400 hover:text-white">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-slate-400 hover:text-white">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-serif text-white text-lg mb-5">Contacto</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3 text-slate-400">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" style={{ color: "#C5A059" }} />
                <span>
                  {FIRM.address.line1}<br />
                  {FIRM.address.line2}<br />
                  {FIRM.address.city}
                </span>
              </li>
              <li className="flex gap-3 text-slate-400">
                <Mail size={16} className="mt-0.5 flex-shrink-0" style={{ color: "#C5A059" }} />
                <a href={`mailto:${FIRM.email}`} className="hover:text-white">
                  {FIRM.email}
                </a>
              </li>
              <li className="flex gap-3 text-slate-400">
                <Phone size={16} className="mt-0.5 flex-shrink-0" style={{ color: "#C5A059" }} />
                <span>{FIRM.phone}</span>
              </li>
              <li className="flex gap-3 text-slate-400">
                <Clock size={16} className="mt-0.5 flex-shrink-0" style={{ color: "#C5A059" }} />
                <span>{FIRM.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Ospino &amp; Piñeres Abogados &amp; Asociados S.A.S. Todos los derechos reservados.
          </p>
          <p className="text-xs text-slate-500">
            Cartagena de Indias, Colombia
          </p>
        </div>
      </div>
    </footer>
  );
}